import React, {Component} from "react";
import { isSimilarObject, getRadius } from "../../../helper";

export default class LocationItem extends Component {
    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    render() {
        const {location, handleEdit, handleDelete} = this.props;

        return (
            <li className="location-item">
                <div className='location-left'>
                    <h3 className="location-title">{`Заголовок: ${location.title}`}</h3>
                    <h3 className="location-title">{`Адрес (координаты): широта ${location.latitude}, долгота ${location.longitude}`}</h3>
                    <div className="location-comment">{`Комментарий к адресу: ${location.comment || 'Не указан'}`}</div>
                    <div className="location-radius" style={{marginTop:'8px'}}>{`Радиус: ${getRadius(location.radius)}`}</div>
                </div>
                <div className='location-right'>
                    <span className="small-button detail-transaction" style={{marginBottom:'10px'}}>
                        <button style={{width:'100%'}} onClick={() => handleEdit(location)}>
                            Изменить
                        </button>
                    </span>
                    <span className="small-button detail-transaction">
                        <button style={{width:'100%'}} onClick={() => handleDelete(location)}>
                            Удалить
                        </button>
                    </span>
                </div>
            </li>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Account/Locations/LocationTrackerItem.js